import React from 'react';
import MetricScatterChart from './MetricScatterChart';

const StatChartTab = ({
  chartTitleTh,
  chartTitleEn,
  yAxisLabel,
  data,
  loading,
  color,
  avgSuffix,
  lang,
}) => {
  const l = (th, en) => (lang === 'th' ? th : en);

  const formatAvg = (d, suffix) => {
    if (!d || d.avg == null || isNaN(d.avg)) return '-';
    return d.avg.toFixed(2) + (suffix || '');
  };

  const getChartPoints = (d) => (d && d.data) ? d.data.map(item => item.value) : [];
  const getChartLabels = (d) => (d && d.data) ? d.data.map(item => item.name) : [];

  const renderLoading = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 520,
      flexDirection: 'column',
      color: '#666'
    }}>
      <i className="fas fa-spinner fa-spin fa-3x" style={{ marginBottom: 16 }} />
      <span>{l('กำลังโหลดข้อมูล...', 'Loading...')}</span>
    </div>
  );

  return (
    <React.Fragment>
      <div className="chart-head">
        <h3 style={{ marginTop: 0 }}>{l(chartTitleTh, chartTitleEn)}</h3>
        <div className="chart-sub">
          {l('ค่าเฉลี่ย', 'Average')}: {formatAvg(data, avgSuffix)}
        </div>
      </div>
      {loading ? renderLoading() : (
        <MetricScatterChart
          title=""
          yAxisLabel={yAxisLabel}
          xAxisLabel={l('อาคาร', 'Building')}
          averageText=""
          points={getChartPoints(data)}
          labels={getChartLabels(data)}
          color={color}
          height={520}
          hideInlineTitle
          withLine={false}
        />
      )}
    </React.Fragment>
  );
};

export default StatChartTab;



// WEBPACK FOOTER //
// ./src/components/charts/StatChartTab.js